import * as authTypes from "../../types/admin/authTypes";

export const adminLoginReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case authTypes.ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        adminInfo: payload,
        error: "",
      };
    case authTypes.ADMIN_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        adminInfo: {},
      };
    case authTypes.ADMIN_LOGOUT:
      return {
        adminInfo: null,
      };
    default:
      return state;
  }
};

export const adminRegisterReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case authTypes.ADMIN_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        adminInfo: payload,
        error: "",
      };
    case authTypes.ADMIN_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        adminInfo: null,
        error: payload,
      };
    case authTypes.ADMIN_LOGOUT:
      return {
        adminInfo: null,
      };
    default:
      return state;
  }
};

export const adminRegisterSuperReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_REGISTER_SUPER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case authTypes.ADMIN_REGISTER_SUPER_SUCCESS:
      return {
        ...state,
        loading: false,
        adminInfo: payload,
        error: "",
      };
    case authTypes.ADMIN_REGISTER_SUPER_FAIL:
      return {
        ...state,
        loading: false,
        adminInfo: null,
        error: payload,
      };
    default:
      return state;
  }
};

export const adminUpdateDetailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_UPDATE_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
      };
    case authTypes.ADMIN_UPDATE_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        adminDetailInfo: payload,
        detailError: "",
      };
    case authTypes.ADMIN_UPDATE_DETAIL_FAIL:
      return {
        ...state,
        detailLoading: false,
        adminDetailInfo: null,
        detailError: payload,
      };
    default:
      return state;
  }
};

export const adminChangePasswordReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        UpdatePassloading: true,
      };
    case authTypes.ADMIN_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        UpdatePassLoading: false,
        adminUpdatePassInfo: payload,
        UpdatePassError: "",
      };
    case authTypes.ADMIN_CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        UpdatePassLoading: false,
        adminUpdatePassInfo: null,
        UpdatePassError: payload,
      };
    default:
      return state;
  }
};

export const adminChangeImageReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_UPDATE_IMAGE_REQUEST:
      return {
        ...state,
        updateAdminImageLoading: true,
      };
    case authTypes.ADMIN_UPDATE_IMAGE_SUCCESS:
      return {
        ...state,
        updateAdminImageLoading: false,
        adminUpdateImageInfo: payload,
        updateAdminImageError: "",
      };
    case authTypes.ADMIN_UPDATE_IMAGE_FAIL:
      return {
        ...state,
        updateAdminImageLoading: false,
        adminUpdateImageInfo: null,
        updateAdminImageError: payload,
      };
    default:
      return state;
  }
};

export const adminResendEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_RESEND_EMAIL_REQUEST:
      return {
        ...state,
        resendEmailLoading: true,
      };
    case authTypes.ADMIN_RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        resendEmailLoading: false,
        adminResendEmailInfo: payload,
        resendEmailError: "",
      };
    case authTypes.ADMIN_RESEND_EMAIL_FAIL:
      return {
        ...state,
        resendEmailLoading: false,
        adminResendEmailInfo: null,
        resendEmailError: payload,
      };
    default:
      return state;
  }
};

export const adminOnBoardReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.ADMIN_ONBOARD_COMPLETE_REQUEST:
      return {
        ...state,
        adminOnboardLoading: true,
      };
    case authTypes.ADMIN_ONBOARD_COMPLETE_SUCCESS:
      return {
        ...state,
        adminOnboardLoading: false,
        adminOnboardInfo: payload,
        adminOnboardError: "",
      };
    case authTypes.ADMIN_ONBOARD_COMPLETE_FAIL:
      return {
        ...state,
        adminOnboardLoading: false,
        adminOnboardInfo: null,
        adminOnboardError: payload,
      };
    default:
      return state;
  }
};

export const resendOtpBySmsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.RESEND_OTP_BY_SMS_REQUEST:
      return {
        ...state,
        resendOtpBySmsLoading: true,
      };
    case authTypes.RESEND_OTP_BY_SMS_SUCCESS:
      return {
        ...state,
        resendOtpBySmsLoading: false,
        resendOtpBySmsInfo: payload,
        resendOtpBySmsError: "",
      };
    case authTypes.RESEND_OTP_BY_SMS_FAIL:
      return {
        ...state,
        resendOtpBySmsLoading: false,
        resendOtpBySmsInfo: null,
        resendOtpBySmsError: payload,
      };
    default:
      return state;
  }
};

export const updateOtpBySmsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.UPDATE_OPT_BY_SMS_REQUEST:
      return {
        ...state,
        updateOtpBySmsLoading: true,
      };
    case authTypes.UPDATE_OPT_BY_SMS_SUCCESS:
      return {
        ...state,
        updateOtpBySmsLoading: false,
        updateOtpBySmsInfo: payload,
        updateOtpBySmsError: "",
      };
    case authTypes.UPDATE_OPT_BY_SMS_FAIL:
      return {
        ...state,
        updateOtpBySmsLoading: false,
        updateOtpBySmsInfo: null,
        updateOtpBySmsError: payload,
      };
    default:
      return state;
  }
};

export const resendOtpByEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.RESEND_OTP_BY_EMAIL_REQUEST:
      return {
        ...state,
        resendOtpByEmailLoading: true,
      };
    case authTypes.RESEND_OTP_BY_EMAIL_SUCCESS:
      return {
        ...state,
        resendOtpByEmailLoading: false,
        resendOtpByEmailInfo: payload,
        resendOtpByEmailError: "",
      };
    case authTypes.RESEND_OTP_BY_EMAIL_FAIL:
      return {
        ...state,
        resendOtpByEmailLoading: false,
        resendOtpByEmailInfo: null,
        resendOtpByEmailError: payload,
      };
    default:
      return state;
  }
};

export const updateOtpByEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.UPDATE_OPT_BY_EMAIL_REQUEST:
      return {
        ...state,
        updateOtpByEmailLoading: true,
      };
    case authTypes.UPDATE_OPT_BY_EMAIL_SUCCESS:
      return {
        ...state,
        updateOtpByEmailLoading: false,
        updateOtpByEmailInfo: payload,
        updateOtpByEmailError: "",
      };
    case authTypes.UPDATE_OPT_BY_EMAIL_FAIL:
      return {
        ...state,
        updateOtpByEmailLoading: false,
        updateOtpByEmailInfo: null,
        updateOtpByEmailError: payload,
      };
    default:
      return state;
  }
};

export const regenrateTokenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.REGENERATE_TOKEN_REQUEST:
      return {
        ...state,
        regTokenLoading: true,
      };
    case authTypes.REGENERATE_TOKEN_SUCCESS:
      return {
        ...state,
        regTokenLoading: false,
        regTokenInfo: payload,
        regTokenError: "",
      };
    case authTypes.REGENERATE_TOKEN_FAIL:
      return {
        ...state,
        regTokenLoading: false,
        regTokenInfo: null,
        regTokenError: payload,
      };
    default:
      return state;
  }
};

export const loginUsingTokenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.LOGIN_USING_TOKEN_REQUEST:
      return {
        ...state,
        tokenLoginLoading: true,
      };
    case authTypes.LOGIN_USING_TOKEN_SUCCESS:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginInfo: payload,
        tokenLoginError: "",
      };
    case authTypes.LOGIN_USING_TOKEN_FAIL:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginInfo: null,
        tokenLoginError: payload,
      };
    default:
      return state;
  }
};

export const changingTokenReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.CHANGING_TOKEN_REQUEST:
      return {
        ...state,
        tokenLoginLoading: true,
      };
    case authTypes.CHANGING_TOKEN_SUCCESS:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginInfo: payload,
        tokenLoginError: "",
      };
    case authTypes.CHANGING_TOKEN_FAIL:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginInfo: null,
        tokenLoginError: payload,
      };
    default:
      return state;
  }
};
export const resendSignUpOtpBySmsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.RESEND_SIGN_UP_OTP_BY_SMS_REQUEST:
      return {
        ...state,
        resendSignUpOtpBySmsLoading: true,
      };
    case authTypes.RESEND_SIGN_UP_OTP_BY_SMS_SUCCESS:
      return {
        ...state,
        resendSignUpOtpBySmsLoading: false,
        resendOtpBySmsInfo: payload,
        resendOtpBySmsError: "",
      };
    case authTypes.RESEND_SIGN_UP_OTP_BY_SMS_FAIL:
      return {
        ...state,
        resendSignUpOtpBySmsLoading: false,
        resendOtpBySmsInfo: null,
        resendOtpBySmsError: payload,
      };
    default:
      return state;
  }
};
export const confirmSignUpOtpBySmsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_REQUEST:
      return {
        ...state,
        confirmSignUpOtpBySmsLoading: true,
      };
    case authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_SUCCESS:
      return {
        ...state,
        confirmSignUpOtpBySmsLoading: false,
        confirmSignUpOtpBySmsInfo: payload,
        confirmSignUpOtpBySmsError: "",
      };
    case authTypes.CONFIRM_SIGN_UP_OPT_BY_SMS_FAIL:
      return {
        ...state,
        confirmSignUpOtpBySmsLoading: false,
        confirmSignUpOtpBySmsInfo: null,
        confirmSignUpOtpBySmsError: payload,
      };
    default:
      return state;
  }
};
